<template>
  <div>
    <b-card bg-variant="light"
            class="permissions"
            header="Permissions"
            header-bg-variant="dark"
            header-text-variant="white">

      <b-button :pressed.sync="showFilter"
                class="mb-2">
        FILTER
      </b-button>

      <b-table :current-page="currentPage"
               :fields="fields"
               :items="roles"
               :per-page="perPage"
               class="table-responsive"
               head-variant="light"
               hover
               responsive
               striped>

        <template v-slot:top-row="{fields}">
          <proposal-filter :id="id"
                           v-model="roles"
                           :fields="fields"
                           :not-include-key="['ordinalNumber']"/>
        </template>

        <template v-slot:cell(ordinalNumber)="row">
          <base-column-ordinal-number v-bind="{index: row.index, perPage, currentPage}"/>
        </template>

        <template v-slot:cell(permissions)="row">
          <b-badge v-for="item in row.item.permissions" :key="item">
            {{ item }}
          </b-badge>
        </template>
      </b-table>
      <b-table-footer v-model="loading"
                      :current-page="currentPage"
                      :data-length="roles.length"
                      :per-page="perPage"
                      @change-page="changePage">
        <template v-slot>
          <base-per-page-input v-model="perPage"/>
        </template>
      </b-table-footer>
    </b-card>
  </div>
</template>

<script>
  import BTableFooter from '@/components/BTableFooter';
  import BasePerPageInput from '@/components/base-components/BasePerPageInput';
  import BaseColumnOrdinalNumber from '@/components/base-components/BaseColumnOrdinalNumber';
  import ProposalFilter from '@/components/ProposalFilter';
  import { ordinalNumber } from '@/helpers/commonTableColumns';

  export default {
    name: 'PermissionsDashboard',
    components: {
      ProposalFilter,
      BaseColumnOrdinalNumber,
      BasePerPageInput,
      BTableFooter,
    },
    data() {
      return {
        roles: [],
        fields: [
          ordinalNumber,
          {
            key: 'name',
            label: 'Role',
          },
          'permissions',
        ],
        loading: false,
        currentPage: 1,
        perPage: 20,
        id: 1,
        showFilter: true,
      };
    },
    methods: {
      loadData() {
        this.loading = true;
        this.axios.get('/roles/permissions')
          .then((resp) => {
            this.roles = resp.data;
            this.$emit('setup-proposal', this.roles);
          })
          .catch(() => {
            this.$notify({ type: 'error', title: 'Cannot load data' });
          })
          .finally(() => {
            this.loading = false;
          });
      },
      changePage(val) {
        this.currentPage = val;
      },
    },
    created() {
      this.loadData();
    },
    watch: {
      showFilter() {
        this.$emit('toggle-show');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .permissions .badge {
    background-color: $color-mint;
    padding: 4px 10px;
    font-weight: normal;
    margin: 5px;
    font-size: 1rem;
  }

  .card {
    margin: 4rem !important;
  }
</style>
